const apiEndPoints = {
  methodType: {
    PUT: 'put',
    GET: 'get',
    POST: 'post',
    DELETE: 'delete',
    PATCH: 'patch',
  },
  verifyUser: '/user-verification',
  verifySubDomain: '/sub-domain-verification',
  listUserTenants: '/list-user-tenants',
  signupMultiTenantEmail: '/signup-multi-tenant-mail',
  userContext: '/user-context',
  mfa: {
    setup: '/mfa-setup',
    verify: '/mfa-verify',
    sendSms: '/mfa-send-sms',
    updateSmsUsage: '/auth/update-sms-usage',
    resetTOTP: '/mfa-reset-totp',
  },
  contact: {
    create: '/create-contact',
    phoneValidation: '/validate-phone',
    list: '/list-contacts',
    details: '/view-contact-details',
    update: '/update-contact-details',
    upcomingDates: '/contact-upcoming-dates',
    relatedTasks: '/contact-related-tasks',
    relatedFiles: '/contact-related-files',
    emailValidation: '/email-checker',
  },
  practiceArea: '/list-practice-area',
  createCaseTag: '/create-tag',
  createCustomField: '/create-custom-field',
  getCaseTag: '/list-tags',
  getCaseStage: '/list-case-stages',
  createCase: '/create-case',
  getContact: '/list-contacts',
  getCase: '/list-cases',
  getCaseDetails: '/view-case-details',
  getConflictCheck: '/conflict-check',
  getCustomFieldList: '/list-custom-fields',
  getCaseMatter: '/list-case-matters',
  updateCase: '/update-case-details',
  getCompanionCase: '/get-companion',
  createCompanionCase: '/create-companion',
  updateCompanionCase: '/update-companion',
  deleteCase: '/delete-case',
  closeCase: '/close-case',
  deleteCustomField: '/delete-custom-field',
  updateCustomFieldOrder: '/update-position',
  updateCustomField: '/update-custom-field-details',
  createCaseMatter: '/create-case-matter',
  updateCaseMatter: '/update-case-matter-details',
  deleteCaseMatter: '/delete-case-matter',
  listCaseMatter: '/list-case-matters',
  caseTimeLineUpdate: 'edit-case-timeline',
  user: {
    create: '/create-user',
    list: '/list-users',
    details: '/view-user-details',
    update: '/update-user',
    getProfile: '/get-user-profile',
    updateProfile: '/update-user-profile',
    setKpiTrackig: '/set-kpi-tracking',
    rdsList: '/list-users-rds',
  },
  getCaseNumberValidation: '/case-number-exists',
  createPracticeArea: '/create-practice-area',
  listPracticeArea: '/list-practice-area',
  updatePracticeArea: '/update-practice-area-details',
  deletePracticeArea: '/delete-practice-area',
  createCaseStage: '/create-case-stage',
  updateCaseStage: '/update-case-stage-details',
  deleteCaseStage: '/delete-case-stage',
  updateCaseStagePosition: '/stage-position-update',
  getUserCases: '/list-attached-cases',
  createContactGroup: '/create-contact-group',
  deleteContactGroup: '/delete-contact-group',
  updateContactGroup: '/update-contact-group-details',
  listContactGroup: '/list-contact-groups',
  calendar: {
    createEvent: '/create-event',
    getEvent: '/get-events',
    listEvents: '/list-events',
    listEventsV2: '/list-events-v2',
    listGoogleCalendars: '/list-google-calendars',
    deleteEvent: '/delete-event',
    updateEvent: '/update-event',
    listEventTypes: '/list-event-types',
    createEventType: '/create-event-type',
    updateEventType: '/update-event-type-details',
    deleteEventType: '/delete-event-type',
    userList: '/case-user-client-details',
    updateSettings: '/update-calendar-settings',
    getSettings: '/get-calendar-settings',
    getFreeTime: '/fetch-free-times',
    calendarAttendees: '/calendar_attendees',
    getSideBarUsers: '/list-calendar-users',
    // google calendar api
    generateAuthUrl: '/generate-google-auth-url',
    generateToken: '/generate-google-tokens',
  },
  intakeForm: {
    createClientForm: '/create-form',
    updateClientForm: '/update-form',
    deleteClientForm: '/delete-form',
    listClientForm: '/list-forms',
    getFormData: '/get-forms',
    getClientForm: '/fetch-shared-form',
    shareClientForm: '/share-intake-form',
    saveClientForm: '/save-shared-form',
    listCaseForms: '/list-saved-forms',
    viewCaseForm: '/view-saved-form',
    deleteCaseForm: '/delete-saved-form',
    reSendForm: '/resend-intake-form',
    listLeadIntakes: '/list-pending-leads',
    deleteLeadIntake: '/reject-lead-form',
    saveLeadIntake: '/save-lead-form',
    getLeadForm: '/fetch-lead-form',
    getGeneralList: '/general-list-apis',
    listSentForms: '/list-sent-forms',
    markAsRead: '/sent-form-mark-as-read',
  },
  listLeadStages: '/list-lead-stages',
  createLeadStage: '/create-lead-stage',
  updateLeadStage: '/update-lead-stage-details',
  deleteLeadStage: '/delete-lead-stage',
  // Lawft ID APIs
  listLawftIds: '/lawft-id-settings-list',
  createLawftId: '/lawft-id-settings',
  updateLawftId: '/lawft-id-settings',
  deleteLawftId: '/lawft-id-settings',
  getOfficeLocations: '/list-office-locations',
  getOfficeLocationsV2: '/list-office-locations-v2',
  createOfficeLocation: '/create-office-location',
  updateOfficeLocation: '/update-office-location-details',
  deleteOfficeLocation: '/delete-office-location',
  // Conference Room APIs
  listConferenceRooms: '/conference-room',
  createConferenceRoom: '/conference-room',
  updateConferenceRoom: '/conference-room',
  deleteConferenceRoom: '/conference-room',
  getConferenceRoomAvailability: '/conference-rooms/availability',
  createCaseNote: '/create-case-note',
  listCaseNote: '/list-case-notes',
  deleteCaseNote: '/delete-case-note',
  updateCaseNote: '/update-case-note-details',
  getNoteDetails: '/view-case-note-details',
  downloadCaseNotesPDF: '/get-case-pdf',
  createCaseCourt: '/create-court-location',
  createCaseMessage: '/create-message',
  createCaseMessageV2: '/secure-messages-v2',
  autoSave: '/get-autosave',
  listMessages: '/list-messages',
  listMessagesV2: '/list-messages-v2',
  viewMessageThreadDetails: '/view-message-thread-details',
  getThreadReplies: '/messages/thread-replies',
  getThreadDetails: '/messages-v2/thread-details',
  getSideBarMessages: '/get-sidebar-messages',
  listSidebarMessages: '/messages-v2/sidebar/list',
  createMessageReply: '/create-message-reply',
  updateMessageThread: '/update-message-thread',
  updateReadPointer: '/messages-v2/read-pointer',
  getTaskList: '/list-task',
  listTasksV2: '/task-list-v2',
  listTaskAgendaView: '/task/v2/list-task-agenda-view',
  createTask: '/create-task',
  deleteTask: '/delete-task',
  updateTask: '/update-task',
  updateTaskDetails: '/update-task',
  getTaskDetails: '/get-task',
  getNotifications: '/list-notifications',
  markNotification: '/notification-mark-as-read',
  clearAllNotifications: '/clear-all-notifications',
  getNotificationCount: 'get-notification-count',
  resetNotificationCount: '/reset-notification-count',
  caseNotificationSummary: '/case-notification-summary',
  resetCaseNotificationSummary: '/reset-case-notification-summary',
  clientNotificationCount: '/get-notification-count',
  clientNotificationMarkAsRead: '/update-client-read-status',

  // Announcements
  listAnnouncements: '/announcements',
  createAnnouncement: '/announcements',
  dismissAnnouncement: '/announcements/dismiss',
  createLead: '/create-lead',
  viewLeadDetails: '/view-lead-details',
  listLeads: '/list-leads',
  listLeadsV2: '/list-leads-v2',
  updateLeadDetails: '/update-lead-details',
  deleteLead: '/delete-lead',
  closeLead: '/close-lead',
  fileManager: {
    file: '/file',
    fileClients: '/list-target-clients',
    sendESignature: '/send-signature-request',
    sendESignatureZoho: '/esign-request',
    generateSignUrl: '/esign-sign-url',
    generateSignUrlMail: '/esign-sign-url-mail',
    getSignatureStatus: '/esign-sign-status',
    fileReadStatus: '/file-read-status',
    getFolderContent: '/get-folder-content',

    getFile: '/get-file',
    sendESignatureToAdmin: '/send-signature-response',
    tagFile: '/tag-file',
    listFileTags: '/list-file-tags',
    copyFileUrl: '/generate-lawft-link',
    getSharedFiles: '/fetch-shared-files',
    getSharedLinkStats: '/lawft-link-stats',

    summarizeDocument: '/summarize-document',
    saveSummary: '/save-summary',
    courtDateEvent: '/court-date',
    detectDiscrepancy: '/detect-discrepancy',
    getDiscrepancies: '/get-discrepancy',
    recallSignature: '/esign-recall-request',
    listGroupedFiles: '/list-grouped-files',
    extractEntities: '/extract-entities',
    getEntities: '/get-entities',
    createTimeline: '/create-timeline',
    getTimeline: '/get-timeline',
  },
  createTaskStage: '/create-task-stage',
  getTaskStages: '/list-task-stage',
  deleteTaskStage: '/delete-task-stage',
  updateTaskStage: '/update-task-stage',
  createUserGroup: '/create-user-group',
  listUserGroups: '/list-user-groups',
  deleteUserGroup: '/delete-user-group',
  updateUserGroups: '/update-user-group-details',
  createUserRole: '/create-user-roles',
  listUserRoles: '/list-user-roles',
  userRoleDetails: '/view-user-role-details',
  updateRoleDetails: '/update-user-role-details',
  deleteUserRole: '/delete-user-role',
  convertToCase: '/convert-lead',
  addRelations: '/add-relations',
  deleteRelation: '/delete-relation',
  updateRelations: '/update-relation',
  stageUpdate: '/stage-update',
  addTeamMember: '/add-team-member',
  createTimeEntry: '/create-time-entry',
  updateTimeEntry: '/update-time-entry',
  getTimeEntry: '/get-time-entry',
  listTimeEntries: '/list-time-entries',
  listTimeEntriesV2: '/list-time-entries-v2',
  trackBillableHours: '/track-billable-hours',
  createActivityType: '/create-activity-type',
  updateActivityType: '/update-activity-type',
  getActivityTypes: '/get-activity-type',
  deleteActivityTypes: '/delete-activity-type',
  listActivityTypes: '/list-activity-type',
  deleteTimeEntry: '/delete-time-entry',
  getSummaryOfTimeEntries: '/get-summary-time-entries',
  leadCloseReason: '/create-lead-closure-reason',
  deleteCaseTeamMember: '/delete-team-member',
  deleteCaseTeamGroup: '/delete-case-group',
  updateTeamMember: '/update-team-member',
  getAuditLogs: '/fetch-audit-logs',
  listExpenses: '/list-expense',
  listExpensesV2: '/list-expense-v2',
  listMedicalExpenses: '/list-medical-expenses',
  listMedicalExpensesV2: '/list-medical-expenses-v2',
  listCaseExpenses: '/list-case-expenses',
  listCaseExpensesV2: '/list-case-expenses-v2',
  getMedicalExpenses: '/get-medical-expense',
  listLeadReferrals: '/list-lead-referrals',
  createLeadReferral: '/create-lead-referral-entity',

  createMedicalExpense: 'create-medical-expense',
  updateMedicalExpense: 'update-medical-expense',
  deleteMedicalExpense: '/delete-medical-expense',

  createCaseexpense: 'create-case-expense',
  getCaseExpenses: '/get-case-expense',
  getSettlementExpenses: '/get-settlement',
  updateSettlementExpenses: '/update-settlement',
  finalSettlement: '/final-settlement',

  // Negotiations APIs
  createOffer: '/create-offer',
  updateOffer: '/update-offer',
  deleteOffer: '/delete-offer',
  listOffers: '/list-offers',

  // Settlement Authority APIs
  addSettlementAuthority: '/add-settlement-authority',
  listAuthoritySettlements: '/list-authority-settlements',
  getSettlementCalculator: '/get-settlement-calculator',
  writeToSettlementCalculator: '/write-to-settlement-calculator',

  // Insurance Provider APIs
  createInsurer: '/create-insurer',
  updateInsurer: '/update-insurer',
  deleteInsurer: '/delete-insurer',
  listInsurers: '/list-insurers',

  updateCaseExpense: 'update-case-expense',
  deleteCaseExpense: '/delete-case-expense',
  deleteExpense: '/delete-expense',
  createExpense: '/create-expense',
  getExpense: '/get-expense',
  updateExpense: '/update-expense',
  createAccount: '/create-account',
  getAccount: '/get-account',
  updateAccount: '/update-account',
  listAccount: '/list-account',
  deleteAccount: '/delete-account',
  createExpenseType: '/create-expense-type',
  updateExpenseType: '/update-expense-type',
  getExpenseType: '/get-expense-type',
  listExpenseType: '/list-expense-type',
  deleteExpenseType: '/delete-expense-type',
  listPaymentStructure: '/list-payment-structure',
  updatePaymentStructure: '/update-payment-structure',
  createTax: '/create-tax',
  updateTax: '/update-tax',
  listTax: '/list-tax',

  createSnippet: '/create-text-snippet',
  updateSnippet: '/update-text-snippet',
  getSnippet: '/list-text-snippets',
  deleteSnippet: '/delete-text-snippet',

  listAutomationRules: '/list-automation-rules',
  createAutomationRules: '/create-automation-rule',
  updateAutomationRules: '/update-automation-rule',
  getAutomationRuleDetails: '/get-automation-rule',
  validateAutomationRule: '/automation-validation',
  manualAutomationTrigger: '/manual-automation-trigger',
  listStoppedAutomationInstances: '/list-stopped-automation-instances',
  listStoppedAutomationInstancesActions: '/list-stopped-instances-actions',
  restartAutomationInstance: '/restart-automation-instance',

  //Intuit Payment
  intuitPayment: '/client-payment',
  getDefaultOperatingAccount: '/default-operating-account',
  listClientCards: '/list-client-cards',
  deleteClientCard: '/delete-customer-card',

  getHourRate: '/get-hour-rate-user',
  createPaymentRequest: '/create-payment-request',
  getPaymentRequest: '/get-payment-request',
  updatePaymentRequest: '/update-payment-request',
  listPaymentRequest: '/list-payment-request',
  deletePaymentRequest: '/delete-payment-request',
  createPaymentRecord: '/create-payment-record',
  getPaymentRecord: '/get-payment-record',
  updatePaymentRecord: '/update-payment-record',
  listPaymentRecord: '/list-payment-record',
  listPaymentRecordV2: '/list-payment-record-v2',
  listPaymentRecordV3: '/list-payment-record-v3',
  listPaymentRequestV2: '/list-payment-request-v2',
  deletePaymentRecord: '/delete-payment-record',
  recordCaseExpensePayment: '/record-case-expense-payment',
  createPaymentRefund: '/create-payment-refund',
  sendRequestMail: '/send-payment-request-email',
  getTrustAccountBalance: '/get-trust-account-balance',
  changeTenant: '/change-tenant',
  deactivateFirmAccount: '/deactivate-firm',
  updateFirmName: '/update-firm-name',
  log_in_out: '/log-in-out',
  createPaymentReminder: '/create-payment-reminder',
  updatePaymentReminder: '/update-payment-reminder',
  createInvoice: '/create-invoice',
  listInvoice: '/list-invoice',
  listInvoiceV2: '/list-invoice-v2',
  getInvoiceNumber: '/get-invoice-number',
  getClientPaymentDetails: '/list-client-payment-details',
  getPresignedURL: '/presigned-post-url',
  presignedURLGet: '/presigned-get-url',
  leadClosureReasons: '/list-lead-closure-reasons',
  getInvoice: '/get-invoice',
  listClientInvoices: '/list-client-invoice-details',
  deleteCaseRelation: '/delete-case-relation',
  updateCaseContact: '/update-case-contact',
  updateCaseContactV2: '/update-case-contact-v2',
  dashboard: '/dashboard-items',
  clientBillingSummary: '/get-client-summary',
  dashBoardDataPointOne: '/dashboard-cards-one',
  dashBoardDataPointTwo: '/dashboard-cards-two',
  dashBoardDataPointThree: '/dashboard-cards-three',
  dashBoardDataPointFour: '/dashboard-cards-four',
  manageTask: '/manage-task-column',
  archiveUser: '/archive-user',
  getSubscriptionPlan: '/get-subscription',
  deleteInvoice: '/delete-invoice',
  updateInvoice: '/update-invoice',
  availablePhoneNumber: '/available-phone-numbers',
  listTextMessage: '/text-message-threads',
  listTextMessageV2: '/text-message-threads-v2',
  textMessageHistory: '/text-message-history',
  textMessageHistoryV2: '/text-message-history-v2',
  updateTextStatus: '/update-text-mesage-status',
  updateTextStatusV2: '/update-text-message-status-v2',
  markTextMessagesAsRead: '/mark-text-messages-as-read',
  sendTextMessage: '/send-text-message',
  purchasePhoneNumber: '/purchase-phone-number',
  listCaseContacts: '/list-case-contacts',
  listTrustAccount: '/list-trust-account',
  listTrustAccountV2: '/list-trust-account-v2',
  caseBillingSummary: '/get-billing-summary-rds',
  batchBillingList: '/batch-billing-list-rds',
  batchBillingAggregate: '/batch-billing-aggregate',
  batchInvoiceCreation: '/batch-invoice-invoker',
  batchBillingAggregate: '/batch-billing-aggregate',
  sendInvoiceEmail: '/send-invoice-email',
  globalSearch: '/global-search',
  globalSearchV2: '/global-search-v2',
  quickSearch: '/quick-search',
  quickSearchV2: '/quick-search-v2',
  listModuleType: '/list-module-type',
  validateModuleType: '/validate-module-type',
  disburseTrustFund: '/fund-disbursal',
  transferTrustFund: '/fund-transfer',

  updateLeadUser: '/update-lead-users',
  createSettings: '/create-setting',
  getSettings: '/get-setting',
  updateSettings: '/update-setting',
  sendInvoice: '/send-invoice',
  getTrustBalanceInfo: '/get-trust-balance-info',

  updateUserPermission: '/update-user-permissions',
  listLeadSources: '/list-lead-source',
  clientDashboard: '/client-dashboard',
  fileSharing: '/file-sharing',
  timeTracker: '/time-tracker',

  generateReport: '/generate-firm-reports',
  reports: '/get-reports',
  exportReports: '/export-report',
  exportFrrReports: '/export-frr',
  saveReport: '/save-firm-reports',
  loadReport: '/list-saved-report',
  getFutureMonths: '/frr',
  getCaseList: '/basic-case-list',
  medicalProvider: '/mpr',
  vendorReport: '/vr',
  getGlanceTotals: '/glance-totals',
  getNpsReport: '/nps-report',
  generateFirmUserCaseReport: '/generate-firm-user-case-report',
  firmUserCaseReportRDS: '/firm_user_case_report_rds',
  firmUserCaseReportCard: '/firm-user-case-report-card-rds',
  firmUserCaseReportList: '/firm-user-case-report-listing-rds',
  userGroupReportRds: '/user-group-report-rds',
  firmUserGroupReportList: '/firm-user-group-report-list',
  firmUserGroupReportSummary: '/firm-user-group-report-summary',
  pastDueReportRds: '/past_due_report_rds',
  pastDueReportCardRds: '/past_due_report_card_rds',
  trustAccountTransactionReportRds: '/trust-account-transactions-report-rds',
  trustAccountTransactionsReport: '/trust-account-transactions-report',
  trustAccountTransactionTotals: '/trust-account-transaction-totals',
  trustBalanceReportCardRds: '/trust-balance-view-report-card',
  trustBalanceReportListingRds: '/trust-balance-view-report-list',
  paymentReportRds: '/payment-report-rds',
  paymentReportCardRds: '/payment-report-card-rds',
  paymentReportListingRds: '/payment-report-listing-rds',
  futureRevenueReportRds: '/future-revenue-report-rds',
  revenueViewReportCard: '/revenue-view-report-card',
  revenueViewReportList: '/revenue-view-report-list',
  invoiceReportRds: '/invoice-report-rds',
  invoiceReportList: '/invoice-report-list',
  invoiceReportTotalsRds: '/invoice-report-totals-rds',
  vendorReportListRds: '/vendor-report-list-rds',
  vendorReportCardRds: '/vendor-report-card-rds',
  medicalProviderReportListRds: '/medical-provider-report-list-rds',
  medicalProviderReportCardRds: '/medical-provider-report-card-rds',
  CaseExpenseReportListRds: '/pi-case-expense-report-list-rds',
  CaseExpenseReportCardRds: '/pi-case-expense-report-card-rds',
  medicalExpenseReportListRds: '/pi-medical-expense-report-list-rds',
  medicalExpenseReportCardRds: '/pi-medical-expense-report-card-rds',
  piSettlementReportListRds: '/pi-settlement-report-list-rds',
  piSettlementReportCardRds: '/pi-settlement-report-card-rds',

  // SOL Report RDS
  solReportRds: '/sol-report-v2',

  // Intake Reports (Beta - Only Outbound Referrals Report is active)
  outboundReferralReportRds: '/outbound_referrals_report_rds',
  leadSourceReportRds: '/lead_source_report_rds',
  inboundReferralReportRds: '/inbound_referrals_report_rds',
  leadReportList: '/lead_report_list',
  leadReportCard: '/lead_report_card',
  conversionReportRds: '/conversion_report_rds',
  conversionReportCardRds: '/conversion_report_card_rds',

  resendInvitation: '/resend-invitation',
  getUserProfile: '/get-user-profile',
  updateUserProfile: '/update-user-profile',
  getNotificationPreferences: '/notification-preferences',
  updateNotificationPreferences: '/notification-preferences',

  listRelationRoles: '/list-relation-roles',
  createRelationRoles: '/create-relation-roles',
  updateRelationRoles: '/update-relation-roles',
  deleteRelationRoles: '/delete-relation-roles',

  listLeadSource: '/list-lead-source',
  createLeadSource: '/create-lead-source',
  updateLeadSource: '/update-lead-source',
  deleteLeadSource: '/delete-lead-source',
  getLeadDescription: '/get-lead-Description',

  getJobTitle: '/job-title',
  createJobTitle: '/job-title',
  updateJobTitle: '/job-title',
  deleteJobTitle: '/job-title',

  listGlobalTags: '/list-global-tags',
  createGlobalTags: '/create-global-tags',
  updateGlobalTags: '/update-global-tags',
  deleteGlobalTags: '/delete-global-tags',

  listBusinessRole: '/list-business-role',
  createBusinessRole: '/create-business-role',
  deleteBusinessRole: '/delete-business-role',
  updateBusinessRole: '/update-business-role',

  listSubscriptionProducts: '/list-subscription-products',
  listPlanDetails: 'fetch-subscription-product-map',
  addCard: '/add-card',
  subscribeToProduct: '/subscribe',
  listCard: 'list-cards',
  changeDefaultCard: '/change-default-card',
  cancelSubscription: '/cancel-Subscription',
  listSubscriptionInvoice: '/list-subscription-invoices',
  getProration: '/prorated-invoice',
  deleteCard: '/delete-card',

  //secure message module edit case section
  chageMessageCase: '/change-message-case',

  //secure message module invite user section
  sendInviteToUser: '/save-invite-user',

  totalCount: '/total-count',

  //outcome for case closure
  listOutcome: '/list-outcome',
  createOutcome: '/create-outcome',
  updateOutcome: '/update-outcome',
  deleteOutcome: '/delete-outcome',
  createOutcomeItem: '/create-outcome-item',

  //closure reason
  deleteClosureReason: '/delete-closure-reason',
  updateClosureReason: '/update-closure-reason',
  createClosureItem: '/create-closure-item',

  //workflow automation - error log API end points
  listAutomationErrorLogs: '/list-automation-error-logs',

  //Single API to fetch list of cases and leads
  listCasesAndLeads: '/list-case-lead',
  bulkDeleteMoveFile: '/bulk-file-operations',
  validateUpload: '/validate-storage',

  // venue
  getVenue: '/list-venue',
  createVenue: '/create-venue',
  updateVenue: '/update-venue',

  //Billing Module/Temporary Funds
  temporaryFunds: 'temp-funds',
  listTemporaryFunds: 'list-temp-funds',
  listTemporaryFundsV2: '/list-temporary-funds-v2',
  getTemporaryFundBalance: 'get-temporary-fund-balance',
  updateTemporaryFundTransaction: 'update-temporary-fund-transaction',

  // Review Request Urls
  listReviewRequestUrls: '/list-review-config',
  createReviewRequestUrl: '/create-review-url',
  updateReviewRequestUrl: '/update-review-config',
  deleteReviewRequestUrl: '/delete-review-url',
  sentReviewRequest: '/send-review-request',

  //Experts
  listExperts: '/list-experts',
  createExpert: '/create-expert',
  updateExpert: '/update-experts',

  //Quickbooks
  getAuthURI: '/generate-auth-url',
  quickBookCallback: '/generate-tokens',

  //Kpi Goals
  listKpiGoals: '/list-kpi-goal',
  createOrResetKpiGoal: '/kpi-goal',
  getKpiSettings: '/kpi/settings',

  //Lawfty Goals
  listLawftyGoals: '/kpi/settings',
  createLawftyGoal: '/kpi/lawfty-goal',
  updateLawftyGoal: '/kpi/lawfty-goal',
  deleteLawftyGoal: '/kpi/lawfty-goal',

  //NPS
  saveNpsScore: '/save-nps-score',
  npsSettings: '/nps-settings',
  getNpsSettings: '/get-nps-settings',
  forceSendNps: '/force-send-nps',

  // Mail Box
  listEmailThreads: '/list-email-threads',
  viewEmailThreadDetails: '/view-email-thread-details',
  sendOutboundMail: '/send-outbound-email',
  reconcileEmail: '/reconcile-emails',
  markEmailsAsRead: '/mark-emails-as-read',

  // Fuzzy Suggestions
  fetchSuggestions: '/fetch-suggestions',

  // Tag In
  manageTagIn: '/manage-tag-in',
  getCurrentTagIn: '/get-tag-in',
  deleteTagIn: '/delete-tag-in',

  //Quickbook
  accountMapping: '/qb-lawft-map',

  //CaptureNow
  mapCaptureNowTenant: '/map-capturenow-tenant',
  getPendingLead: '/get-pending-lead',

  // fax
  sendFax: '/fax/send-fax',
  purchaseFaxNumber: '/fax/purchase-number',
  listOutgoingFax: '/fax/list-outgoing-faxes',
  faxListCountries: '/fax/list-countries',
  listAvailableFaxNumbers: '/fax/list-available-numbers',
  listFaxAreaCodes: '/fax/list-area-codes',
  IncomingFaxList: '/fax/incoming-fax',
  AssignFaxToCase: '/fax/assign-case',
  getFaxDetails: '/fax/detail',

  invoiceTimeEntry: '/invoice-time-entry',
  invoiceExpenses: '/invoice-expenses',
  invoiceQuickBooksUpdate: '/invoice-quickbook-update',
  taskComments: '/task-comments',

  cancelScheduledMessage: '/cancel-scheduled-message',

  // Automation Settings
  getAutomationSettings: '/get-automation-settings',
  updateAutomationSettings: '/update-automation-settings',

  //Trust Horizon
  getTrustHorizonInfo: '/fetch-lawft-horizon-card',

  // Case Automation
  caseAutomationInstanceActions: '/case-automation-instance-actions',
  skipCaseActionInstance: '/skip-case-action-instance',

  //Referred Out Reason
  listReferredOutReasons: '/list-referred-out-reasons',
  createReferredOutReason: '/create-referred-out-reason',
  updateReferredOutReason: '/update-referred-out-reason',
  deleteReferredOutReason: '/delete-referred-out-reason',

  // Global dropdown
  globalDropdown: '/global-dropdown',
};

export default apiEndPoints;
